export var FindingExclusionDetectorType;
(function (FindingExclusionDetectorType) {
    FindingExclusionDetectorType["FINDING_EXCLUSION_DETECTOR_TYPE_RANSOMWARE_BEHAVIOR"] = "RANSOMWARE_BEHAVIOR";
    FindingExclusionDetectorType["FINDING_EXCLUSION_DETECTOR_TYPE_DATA_ANOMALY"] = "DATA_ANOMALY";
    FindingExclusionDetectorType["FINDING_EXCLUSION_DETECTOR_TYPE_MALWARE"] = "MALWARE";
})(FindingExclusionDetectorType || (FindingExclusionDetectorType = {}));
